<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M8 21v-2H4q-.82 0-1.41-.59-.6-.59-.59-1.41V5q0-.82.59-1.41Q3.18 2.99 4 3h16q.83 0 1.41.59.6.58.59 1.41v12q0 .83-.59 1.41-.59.6-1.41.59h-4v2zm-4-4h16V5H4z"
      />
      <path
        fill="inherit"
        stroke="none"
        fill-rule="evenodd"
        d="M16.43 7.6q.15-.03.3.04.17.06.2.24.04.18-.03.31l-1.33 2.38A6.83 6.83 0 0 1 19 16H5a6.8 6.8 0 0 1 3.43-5.42L7.1 8.2l.14-.52a1 1 0 0 1 .33-.07q.15 0 .23.18l1.37 2.45q.7-.3 1.4-.44a6.5 6.5 0 0 1 2.86 0q.7.15 1.4.44l1.37-2.45q.07-.15.23-.18m-7.4 5.43a.8.8 0 0 0-.62.26.8.8 0 0 0-.26.61q0 .35.26.61a.84.84 0 0 0 1.23 0 .84.84 0 0 0 0-1.22.8.8 0 0 0-.61-.26m5.94 0a.8.8 0 0 0-.6.26.84.84 0 0 0 0 1.22.84.84 0 0 0 1.22 0 .8.8 0 0 0 .26-.61.8.8 0 0 0-.26-.61.8.8 0 0 0-.62-.26"
        clip-rule="evenodd"
      />
    </svg>
  </span>
</template>
